import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  FILTER_NAME_SUB_MENU,
  TASK_STATUS_FILTER_NAME,
} from '../../../constants/filter'
import {
  PAGE_DEFAULT_VALUE,
  SUBMENU_DEFAULT_VALUE,
} from '../../../constants/route'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'
import {
  isTaskDone,
  isTaskDoneCommitType,
  TASK_ACTION_ATTACH_EMAILS,
  TASK_ACTION_ATTACH_FILE,
  TASK_ACTION_MARK_AS_DONE,
  TASK_ACTION_MARK_AS_HIDDEN,
  TASK_ACTION_MARK_AS_OPEN,
  TASK_ACTION_MARK_AS_SHARED,
  TASK_ACTION_SEND_TO_DWELLER,
  TASK_ACTION_SEND_TO_PROVIDER,
} from '../../Task'

import {
  REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_DOCUMENT_STORAGE,
  REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_REQUEST_FOLDER,
  REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_EDIT,
  REQUEST_PROFILE_OPEN_ACTIVITIES_ORDERING,
  REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE,
  REQUEST_PROFILE_OPEN_ACTIVITIES_STATUS,
} from './RequestProfileOpenActivities.constants'

export function getRequestProfileOpenActivitiesResponseItems(response) {
  return response?.data?.items || EMPTY_LIST
}

export function getRequestProfileOpenActivitiesNextStepCount(
  total,
  visibleCount
) {
  return Math.min(
    REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE,
    total - visibleCount
  )
}

export function getRequestProfileOpenActivitiesFooterButtonText({
  isAllShown,
  isLoadingMore,
  nextStepCount,
  t,
}) {
  if (!isLoadingMore) {
    return isAllShown
      ? t('Common.ListShowLessBtnKey')
      : t('RequestProfileOpenActivities.ShowNextItemsKey', {
          itemsCount: nextStepCount,
        })
  }
}

export function getRequestProfileOpenActivitiesFilters(requestId) {
  return {
    [FILTER_NAME_SUB_MENU]: SUBMENU_DEFAULT_VALUE,
    [TASK_STATUS_FILTER_NAME]: [REQUEST_PROFILE_OPEN_ACTIVITIES_STATUS],
    request: [requestId],
  }
}

export function getRequestProfileOpenActivitiesApiParams({
  ordering = REQUEST_PROFILE_OPEN_ACTIVITIES_ORDERING,
  page = PAGE_DEFAULT_VALUE,
  requestId,
  size = REQUEST_PROFILE_OPEN_ACTIVITIES_PAGE_SIZE,
}) {
  return {
    filters: getRequestProfileOpenActivitiesFilters(requestId),
    ordering,
    page,
    size,
  }
}

export function getRequestProfileOpenActivitiesCanChangeStatus(item) {
  const { permissions = EMPTY_OBJECT } = item

  return isTaskDone(item)
    ? permissions.can_mark_as_open || permissions.can_set_yesno_status_as_null
    : permissions.can_mark_as_done ||
        permissions.can_set_yesno_status_as_no ||
        permissions.can_set_yesno_status_as_yes
}

export function getRequestProfileOpenActivitiesItemActions(
  item,
  { canEdit } = EMPTY_OBJECT
) {
  const { permissions = EMPTY_OBJECT } = item

  const isDone = isTaskDone(item)
  const isVisible = item.visible_to_tenant
  const isDoneType = isTaskDoneCommitType(item)

  const canMarkAsDone = isDoneType && permissions.can_mark_as_done
  const canMarkAsOpen = isDoneType && permissions.can_mark_as_open

  const items = [
    {
      label: 'RequestProfileTabActivities.EditActivityActionKey',
      permission: canEdit,
      value: REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_EDIT,
    },
    {
      label: 'Tasks.MarkAsDoneActionOptionKey',
      permission: canMarkAsDone && !isDone,
      value: TASK_ACTION_MARK_AS_DONE,
    },
    {
      label: 'Tasks.MarkAsOpenActionOptionKey',
      permission: canMarkAsOpen && isDone,
      value: TASK_ACTION_MARK_AS_OPEN,
    },
    {
      label: 'Tasks.MarkAsSharedActionOptionKey',
      permission: permissions.can_show_for_dwellers && !isVisible,
      value: TASK_ACTION_MARK_AS_SHARED,
    },
    {
      label: 'Tasks.MarkAsHiddenActionOptionKey',
      permission: permissions.can_hide_for_dwellers && isVisible,
      value: TASK_ACTION_MARK_AS_HIDDEN,
    },
    {
      label: 'RequestProfileTabActivities.SendEmailToProviderActionKey',
      permission: permissions.can_send_email_to_provider,
      value: TASK_ACTION_SEND_TO_PROVIDER,
    },
    {
      label: 'RequestProfileTabActivities.SendEmailToApplicantActionKey',
      permission: permissions.can_send_email_to_dweller,
      value: TASK_ACTION_SEND_TO_DWELLER,
    },
    {
      label: 'RequestProfileTabActivities.AttachEmailActionKey',
      permission: permissions.can_attach_email,
      value: TASK_ACTION_ATTACH_EMAILS,
    },
    {
      label: 'RequestProfileTabActivities.AttachFromDesktopActionKey',
      permission: permissions.can_manage_files,
      value: TASK_ACTION_ATTACH_FILE,
    },
    {
      label: 'RequestProfileTabActivities.AttachFromDocumentStorageActionKey',
      permission: permissions.can_manage_files,
      value:
        REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_DOCUMENT_STORAGE,
    },
    {
      label: 'RequestProfileTabActivities.AttachFromRequestFolderActionKey',
      permission: permissions.can_manage_files,
      value: REQUEST_PROFILE_OPEN_ACTIVITIES_ACTION_ATTACH_FROM_REQUEST_FOLDER,
    },
  ]

  return parseActionsOnValidDivider(filterPermittedActionsWithDividers(items))
}
